<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0">
    <slot />
    <form class="flex flex-col mt-24" @submit.prevent="submitForm">
      <h1 class="text-h3">Get families’ attention with a short and descriptive title</h1>
      <NoteBox v-if="noteBoxMessage" header="Things to consider" :body="noteBoxMessage" />
      <TextArea
        id="adventure-title-textarea"
        ref="textAreaComponent"
        v-model="title"
        labelName="Adventure title"
        :characterCounter="true"
        :minCharacters="minCharacters"
        :maxCharacters="maxCharacters"
        propClasses="resize-none h-full overflow-hidden whitespace-nowrap"
        class="h-56 mt-24 mb-36"
        :status="validationType"
        @textAreaStatus="textAreaStatusHandler"
      />
      <div>
        <button class="text-left link-secondary underline mt-16 mb-24 w-auto" @click.prevent="showExamples">See examples</button>
      </div>
      <StickyButton v-if="!showPopup" :value="isEdit ? 'Save' : 'Next'" />
    </form>
    <Popup v-model="showPopup" popupHeader="Examples" popupSize="lg">
      <TitleExamples />
    </Popup>
  </div>
</template>

<script lang="ts">
// components
import helperStatus from '../../../helpers/status';
import NoteBox from '../../../components/note_box/NoteBox.vue';
import TextArea from '../../../components/textarea/TextArea.vue';
import StickyButton from '../../../components/sticky_button/StickyButton.vue';

import Popup from '../../../components/popup/Popup.vue';
import TitleExamples from '../create/examples/TitleExamples.vue';

export default {
  name: 'Title',
  components: { NoteBox, TextArea, StickyButton, Popup, TitleExamples },
  props: {
    adventureMetaData: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data(): any {
    return {
      title: this.$store.getters['adventures/adventureDraft'].title || '',
      validationType: helperStatus.Neutral,
      showPopup: false,
    };
  },
  computed: {
    titleConstraints(): { __typename: string; field: string; max: number; min: number } {
      return this.adventureMetaData?.constraints.find((constraint) => constraint.field === 'TITLE');
    },
    minCharacters(): number {
      return this.titleConstraints?.min;
    },
    maxCharacters(): number {
      return this.titleConstraints?.max;
    },
    noteBoxMessage(): string {
      return this.adventureMetaData?.categories?.[0].titleExample || '';
    },
  },
  methods: {
    textAreaStatusHandler(validationType) {
      this.validationType = validationType;
    },
    showExamples() {
      this.showPopup = true;
    },
    submitForm() {
      if (this.validationType !== helperStatus.Valid) {
        // @ts-ignore
        this.$refs.textAreaComponent.checkValidation();
      } else {
        this.setTitle();
      }
      return false;
    },
    async setTitle() {
      await this.$store.dispatch('adventures/updateStore', { title: this.title });
      this.$router.push({
        path: this.isEdit ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit` : '/adventures/new/duration',
      });
    },
  },
};
</script>
